import formats from '../../api/formats'
import dialogs from '../common/dialogs.js'
import forms from '../common/forms.js'
import AssistClasses from '../assist/AssistClasses.js'
import people from './index.js'
import client from '../client'
import contactLinks from './ContactLinks.js'
import store from '../../store'

class Strategy extends AssistClasses.Strategy {
  constructor (cxt) {
    super(cxt)
    this.citzenships = []
    this.chipsItems = []
    this.pProps = null
    this.isIndividual = true
    this.editLinkMode = false
  }
  getTypeCode () {
    return 'CONTACT'
  }
  getTypeName () {
    return `Контакт ${this.isIndividual ? 'физического лица' : 'компании'}`
  }
  setContext (cxt) {
    this.context = cxt
  }
  setParentProps (pProps) {
    this.isIndividual = pProps.id != null
    this.pProps = pProps
  }
  createModel () {
    var model = new Model()
    return model
  }
  createModelFromJSON (json) {
    return Object.assign(this.createModel(), JSON.parse(json))
  }
  createDefaultModel (pProps) {
    return Object.assign(this.createModel(), {})
  }
  createModelFromData (data) {
    if (data) {
      data.companyRefCode = data && data.companyRefCode ? data.companyRefCode : null
    }
    return Object.assign(this.createModel(), data)
  }
  updateSteps (scheme) {
    const phoneRules = v => !v || formats.isPhone(formats.formatPhone(v)) || 'Формат номера +7(921)1234567'
    const emailRules = v => !v || formats.isEmail(v) || 'Неверный формат эл. почты'

    let steps = []

    new AssistClasses.Step(
      '',
      (step) => {},
      {
        scheme: [
          {
            fieldType: 'v-text-field',
            label: 'Название',
            name: 'name',
            hint: 'Задает порядок, может заполнятся автоматически',
            grow: true,
            size: {sm8: true, xs12: true},
            if: (model, field) => this.isIndividual
          },
          {
            fieldType: 'v-text-field',
            label: 'Название внутри компании',
            name: 'nameForCompany',
            hint: 'Задает порядок, может заполнятся автоматически',
            grow: true,
            size: {sm8: true, xs12: true}
            // ,
            // if: (model, field) => !this.isIndividual
          },
          {
            fieldType: 'v-chips-field',
            emptyChip: 'Организация',
            name: 'companyRefCode',
            events: {
              'click': (key) => this.selectCompanyRefCode(key),
              'remove': (key) => this.removeCompanyRefCode(key)
            },
            chipSize: this.getIsMobile ? 12 : 25,
            items: (model, field) => {
              return this.chipsItems.filter(i => i.fieldName === 'companyRefCode')
            },
            size: {sm6: true, xs6: true},
            if: (model, field) => this.isIndividual
          },
          {
            fieldType: 'v-text-field',
            label: 'Должность',
            name: 'position',
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-chips-field',
            emptyChip: 'Физ. Лицо',
            name: 'clientIndividualId',
            events: {
              'click': (key) => this.selectIndividualId(key),
              'remove': (key) => this.removeIndividualId(key)
            },
            chipSize: this.getIsMobile ? 12 : 25,
            items: (model, field) => {
              return this.chipsItems.filter(i => i.fieldName === 'clientIndividualId')
            },
            size: {sm6: true, xs6: true},
            if: (model, field) => !this.isIndividual
          },
          {
            fieldType: 'v-text-field',
            label: 'Эл. почта',
            name: 'email',
            rules: Array.of(emailRules),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Тел.',
            name: 'phone',
            rules: Array.of(phoneRules),
            format: formats.formatPhone,
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Адрес',
            name: 'address',
            grow: true,
            size: {sm12: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Заметки',
            name: 'notes',
            grow: true,
            size: {sm12: true, xs12: true}
          },
          {
            fieldType: 'v-chips-field',
            emptyChip: (model, field) => this.editLinkMode ? 'Добавить' : 'Изменить',
            emptyAlways: true,
            emptyEnabled: true,
            name: 'links',
            disabled: (model, field) => !this.editLinkMode,
            events: {
              'click': (key) => this.openLink(key),
              'remove': (key) => this.removeLink(key)
            },
            chipSize: this.getIsMobile ? 12 : 25,
            items: (model, field) => {
              return this.getLinkItems(model)
            },
            size: {sm12: true, xs12: true}
          }
        ]
      },
      {
      }).addToArray(steps)

    this.steps = steps
    this.citzenships = people.citizenships()
    return this
  }
  viewNumber (model) {
    return model['name'] ? model['name'] : '-'
  }
  viewTitle (model) {
    if (this.pProps) {
      return `Контакт ${this.pProps.nameShort}`
    }
    return this.getTypeName()
  }
  viewTitleComp (model) {
    if (this.isIndividual) {
      return formats.createComp(`
        <span>${model['name'] ? model['name'] : this.getTypeName()}</span>
      `)
    } else {
      return formats.createComp(`
        <span>${model['nameForCompany'] ? model['nameForCompany'] : this.getTypeName()}</span>
      `)
    }
  }
  viewContentComp (model) {
    const _f = (v) => v || '-'
    let fields = []
    if (this.isIndividual) {
      fields = [
        {value: _f(model['position']), label: 'Должность:'},
        {value: _f(model['email']), label: 'Эл. почта:'},
        {value: _f(model['phone']), label: 'Тел.:'},
        {value: _f(model['address']), label: 'Адрес:'},
        {value: model['notes'], label: 'Заметки:'}
      ]
    } else {
      fields = [
        {value: _f(model['email']), label: 'Эл. почта:'},
        {value: _f(model['phone']), label: 'Тел.:'},
        {value: _f(model['address']), label: 'Адрес:'},
        {value: model['notes'], label: 'Заметки:'}
      ]
    }
    return {
      template: `
        <div>
          <template v-for="item in fields">
            <span><component :is="renderValueLink(item)"></component></span>
          </template>
          <span>${this.getLinkImgs(model)}</span>
        </div>
        `,
      methods: {
        renderValueLink (item) {
          if (!item.value) {
            return ''
          }
          return store.getters.renderValueLink(item.value, item.label)
        }
      },
      data: () => ({
        fields: fields
      })
    }
  }
  viewContent (model) {
    const _f = (v) => v || '-'
    return `
        Должность: ${_f(model['position'])}\n
        Эл. почта: ${_f(model['email'])}\n
        Тел.: ${_f(model['phone'])}\n
        Адрес: ${_f(model['address'])}\n
        Заметки: ${_f(model['notes'])}\n
    `
  }
  updateModel (model) {
    this.steps.forEach((step) => step.setModel(model))
    this.updateChipsItems(model)
  }
  fetchData (itemId) {
    return new Promise((resolve, reject) => {
      if (itemId) {
        people.getIndividualContact(itemId).then((contact) => {
          resolve(contact)
        })
      } else {
        resolve(null)
      }
    })
  }
  updateData (itemId, model) {
    let item = model
    item['id'] = itemId
    if (this.pProps) {
      if (this.isIndividual) {
        item['clientIndividualId'] = this.pProps.id
      } else {
        item['companyRefCode'] = this.pProps.refCode
      }
    }
    return new Promise((resolve, reject) => {
      this.context.$store.dispatch('updatePeopleContact', item).then(id => {
        resolve(id)
      })
    })
  }
  deleteData (itemId, model) {
    let filled = (this.isIndividual && model['companyRefCode']) || (!this.isIndividual && model['clientIndividualId'])
    let msg = filled ? `Запись будет полностью удалена. Если Вы хотите только отвязать
    контактную информацию от ${this.isIndividual ? 'компании' : 'физ. лица'}, то просто очистите поле` : ''
    return new Promise((resolve, reject) => {
      dialogs.confirm(this.context,
        'Подтвердите',
        `${msg} Удалить запись о контакте?`,
          (self) => {
            self.$store.dispatch('deletePeopleContact', {ids: [itemId]})
              .then(() => resolve())
          })
    })
  }
  getCompanyChipsItem (companyRefCode, company) {
    const getHint = company => {
      return `${company.name} (ИНН: ${formats.formatInn(company.inn)})`
    }
    const getError = company => null
    if (company) {
      let c = company
      return {value: c.ref, text: c.caption, hint: getHint(c), error: getError(c)}
    }
    if (companyRefCode) {
      return {value: companyRefCode, text: '#' + companyRefCode, hint: 'Чтобы видеть название компании, добавьте компанию в Мои Контрагенты', error: null}
    }
    return {}
  }
  addChipsItem (value, text, hint, error) {
    this.chipsItems.push({value: value.toString(), text: text, hint: hint, error: error})
  }
  fetchIndividual (clientIndividualId) {
    return new Promise((resolve, reject) => {
      if (!clientIndividualId) {
        resolve(null)
      } else {
        people.getIndividual(clientIndividualId).then((individual) => {
          resolve(individual)
        })
      }
    })
  }
  fetchCompany (companyRefCode) {
    return new Promise((resolve, reject) => {
      if (!companyRefCode) {
        resolve(null)
      }
      client.getCachedRefs([companyRefCode], (companies) => {
        let company = companies.length > 0 ? companies[0] : null
        resolve(company)
      })
    })
  }
  updateChipsItems (model) {
    this.chipsItems = []
    if (model['companyRefCode']) {
      this.fetchCompany(model['companyRefCode']).then(c => {
        this.chipsItems.push(Object.assign({fieldName: 'companyRefCode'}, this.getCompanyChipsItem(model['companyRefCode'], c)))
      })
    }
    if (model['clientIndividualId']) {
      this.fetchIndividual(model['clientIndividualId']).then(i => {
        if (i) {
          this.chipsItems.push(Object.assign({fieldName: 'clientIndividualId'}, {value: i.id.toString(), text: i.nameShort, hint: null, error: null}))
        }
      })
    }
  }
  selectCompanyRefCode (key) {
    let model = this.steps[0].model
    if (!model.companyRefCode) {
      client.selectRef(this.context, (companies) => {
        model.companyRefCode = companies.length > 0 ? companies[0].ref : null
        model.position = ''
        this.updateChipsItems(model)
      }, () => {}, true, true)
    } else {
      this.openCompanyRefCode(model.companyRefCode)
    }
  }
  openCompanyRefCode (key) {
    let url = store.getters.getClientUrl(key)
    store.dispatch('openLocation', url)
  }
  removeCompanyRefCode (key) {
    let model = this.steps[0].model
    model.companyRefCode = null
    model.position = ''
    this.updateChipsItems(model)
  }
  selectIndividualId (key) {
    const getQuery = () => ''
    let model = this.steps[0].model
    if (!model.clientIndividualId) {
      people.selectIndividual(this.context, null, getQuery, true, true).then((values) => {
        if (Array.isArray(values) && values.length > 0) {
          // console.log('selectIndividualId', values)
          model.clientIndividualId = values[0]
          this.updateChipsItems(model)
        }
      })
    } else {
      this.openIndividualId(model.clientIndividualId)
    }
  }
  openIndividualId (key) {
    people.open(key, true)
  }
  removeIndividualId (key) {
    let model = this.steps[0].model
    model.clientIndividualId = null
    this.updateChipsItems(model)
  }
  openLink (key) {
    console.log('editLinks', key)
    if (this.editLinkMode) {
      let model = this.steps[0].model
      let fmodel = model.links ? JSON.parse(model.links) : []
      let fstrategy = contactLinks.createStrategy(this.cxt)
      let frepo = new AssistClasses.MapRepository((item) => item.link, fmodel)
      fstrategy.setRepo(frepo)
      forms.openFormStg(fstrategy, key).then((key) => {
        model.links = JSON.stringify(frepo.getItems())
      })
    } else {
      if (!key) {
        this.editLinkMode = true
      } else {
        this.context.$store.dispatch('openLocation', key)
      }
    }
  }
  removeLink (key) {
    let model = this.steps[0].model
    let fmodel = model.links ? JSON.parse(model.links) : []
    let frepo = new AssistClasses.MapRepository((item) => item.link, fmodel)
    frepo.delete(key).then(() => {
      model.links = JSON.stringify(frepo.getItems())
    })
  }
  getLinkItems (model) {
    let fmodel = model.links ? JSON.parse(model.links) : []
    let fstrategy = contactLinks.createStrategy(this.cxt)
    let frepo = new AssistClasses.MapRepository((item) => item.link, fmodel)
    return fstrategy.viewChipsList(frepo)
  }
  getLinkImgs (model) {
    let result = ''
    this.getLinkItems(model).forEach(item => {
      result = result.concat(`
        <v-tooltip bottom open-delay="500" max-width="20em">
        <span slot="activator">
        <v-btn style="margin:0" icon small href="${item.value}" target="_blank">
          <img height="16px" width="16px"  src="${item.img}"></img>
        </v-btn>
        </span>
        <span style="overflow-wrap: break-word">${item.hint}</span>
        </v-tooltip>
        `)
    })
    return result
  }

}

class Model {
  constructor () {
    this.modelType = '201.01'
  }
}

function createStrategy (cxt) {
  return new Strategy(cxt)
}

export default {
  createStrategy,
  Model
}



// WEBPACK FOOTER //
// ./src/components/people/Contact.js